




































import { Vue, Component } from 'vue-property-decorator';
import { UserLogin } from '../../common/types';
import { eventBus } from '../../main';
import { SHOW_SNACKBAR } from '../../common/constants';
import { SUPERADMIN_HOME } from '../../common/routes.config';
import errorModule from '../../store/modules/error.module';
import superadminModule from '../../store/modules/superadmin.module';

@Component
export default class SuperAdminLogin extends Vue {
  login: UserLogin = { email: '', password: '' };

  userEmail = '';

  initiatePasswordResetDialog = false;

  async submitLogin(): Promise<void> {
    if (this.login.password.length < 6) {
      eventBus.$emit(
        SHOW_SNACKBAR,
        'Password must be at least 6 characters long.',
      );
      return;
    }
    if (this.login.email.length < 4) {
      eventBus.$emit(SHOW_SNACKBAR, 'Invalid email address.');
      return;
    }
    await superadminModule.superAdminLogin(this.login);
    if (errorModule.hasError) {
      errorModule.clearError();
      return;
    }
    this.$router.push(SUPERADMIN_HOME);
  }
}
